<template>
  <b-form-group :label="label" label-for="input-senhaAcesso">
    <b-form-input
      type="password"
      id="input-senhaAcesso"
      :placeholder="placeholder"
      v-model="compValue"
    />
    <b-button
      class="btn-eye"
      variant="link"
      v-on:click="showPasswordEvent(showPassword)"
    >
      <b-icon
        v-if="showPassword == false"
        icon="eye-slash"
        class="eye"
      ></b-icon>
      <b-icon v-if="showPassword == true" icon="eye" class="eye"></b-icon>
    </b-button>
  </b-form-group>
</template>
<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import AwesomeMask from "awesome-mask";

extend("required", required);

export default {
  props: {
    label: String,
    placeholder: String,
    value: String,
  },
  data() {
    return {
      showPassword: false,
      passwordType: "password",
    };
  },
  components: {},
  computed: {
    compValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("update:value", newValue);
      },
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    showPasswordEvent(show) {
      const password = document.getElementById("input-senhaAcesso");
      const type =
        password.getAttribute("type") == "password" ? "text" : "password";
      document.getElementById("input-senhaAcesso").setAttribute("type", type);
      if (show == true) {
        this.showPassword = false;
      } else this.showPassword = true;
    },
  },
};
</script>
<style scoped>
.btn-eye {
  /* background: #f7f7f7 !important; */
  position: absolute;
  width: 20%;
  height: 50%;
  margin-left: 75%;
  margin-top: -35px;
}
.eye {
  color: gray !important;
  position: absolute;
  margin-top: -10%;
  margin-left: 20%;
}
</style>
